import { useAppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const useTrackPageView = () => {
    const loc = useLocation();
    const appInsCtx = useAppInsightsContext();

    const [name, setName] = useState('');
    const [properties, setProperties] = useState<Record<string, unknown> | null>();

    useEffect(() => {
        const appInsights = appInsCtx.getAppInsights();
        const startTime = new Date();

        const handler = () => {
            const stopTime = new Date();
            const duration = Math.abs(startTime.getTime() - stopTime.getTime()) / 1000;

            if (name) {
                appInsights.trackPageView(
                    {
                        name,
                        uri: loc.pathname
                    },
                    { ...properties, timeSpentOnPage: duration }
                );
            }

            return null;
        };

        return () => {
            handler();
        };
    }, [appInsCtx, loc.pathname, name, properties]);

    return useCallback((name: string, customProperties?: Record<string, unknown>) => {
        setName(name);
        setProperties(customProperties);
    }, []);
};

export default useTrackPageView;
